export default "__VITE_ASSET__6ec21e5b__"